var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.ad_banner.enabled)?_c('div',[_c('hr',{staticClass:"my-4 -mx-6"}),_c('a',{attrs:{"href":_vm.settings.ad_banner.href,"target":"_blank"}},[_c('b-img',{attrs:{"src":_vm.settings.ad_banner.image.src || _vm.settings.ad_banner.image.placeholder,"fluid":""}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }